import React, { useState, useEffect, useCallback } from 'react'
import { Table, Empty, Spin, Button } from 'antd'
import { ReloadOutlined, UserOutlined } from '@ant-design/icons'
import api from '../../api'

const PLATFORM_COLORS = {
  douyin: '#ff4d4f', kuaishou: '#fa8c16', xiaohongshu: '#eb2f96',
  weibo: '#1890ff', bilibili: '#13c2c2', shipinhao: '#52c41a', jinritoutiao: '#722ed1'
}

const PLATFORM_NAMES = {
  douyin: '抖音', kuaishou: '快手', xiaohongshu: '小红书',
  weibo: '微博', bilibili: 'B站', shipinhao: '视频号', jinritoutiao: '头条'
}

function AccountCell({ record }) {
  const name = record.account_remark || record.account_nickname || record.platform_name || '未命名'
  const avatar = record.account_avatar
  const platform = record.platform
  const platformLabel = PLATFORM_NAMES[platform] || platform || '?'
  const color = PLATFORM_COLORS[platform] || '#999'

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <div style={{ position: 'relative', flexShrink: 0 }}>
        <div style={{
          width: 28, height: 28, borderRadius: '50%', overflow: 'hidden',
          border: '1px solid #e8e8e8', background: '#f0f0f0',
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          {avatar ? (
            <img src={avatar} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              onError={e => { e.target.style.display = 'none' }} />
          ) : (
            <UserOutlined style={{ color: '#bbb', fontSize: 12 }} />
          )}
        </div>
        <div style={{
          position: 'absolute', bottom: -1, right: -1,
          width: 13, height: 13, borderRadius: '50%',
          background: color, border: '1.5px solid #fff',
          fontSize: 6, display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: '#fff', fontWeight: 'bold'
        }}>
          {platformLabel[0]}
        </div>
      </div>
      <span style={{ fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 100 }}>
        {name}
      </span>
    </div>
  )
}

export default function ViolationWorksTab() {
  const [violations, setViolations] = useState([])
  const [loading, setLoading] = useState(false)

  const loadData = useCallback(async () => {
    setLoading(true)
    try {
      const res = await api.getViolationWorks()
      if (res.success) setViolations(res.violations || [])
      else setViolations([])
    } catch {
      setViolations([])
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { loadData() }, [loadData])

  const columns = [
    {
      title: '账号名', key: 'account', width: 150, fixed: 'left',
      render: (_, record) => <AccountCell record={record} />
    },
    { title: '作品标题', dataIndex: 'title', key: 'title', width: 180, ellipsis: true },
    {
      title: '发布时间', dataIndex: 'published_at', key: 'published_at', width: 150,
      render: val => {
        if (!val) return '-'
        const d = new Date(val)
        const pad = n => String(n).padStart(2, '0')
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
      }
    },
    {
      title: '违规内容', dataIndex: 'reason', key: 'reason', ellipsis: true,
      render: val => <span style={{ color: '#ff4d4f' }}>{val}</span>
    }
  ]

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', background: '#fff', padding: 16 }}>
      <div style={{ flexShrink: 0, marginBottom: 12, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 12 }}>
        <span style={{ fontSize: 12, color: '#999' }}>共 {violations.length} 条</span>
        <Button icon={<ReloadOutlined />} size="small" onClick={loadData}>刷新</Button>
      </div>

      <div style={{ flex: 1, overflow: 'auto' }}>
        <Spin spinning={loading}>
          {violations.length > 0 ? (
            <Table
              columns={columns}
              dataSource={violations.map((v, i) => ({ ...v, key: v.id || i }))}
              pagination={{ pageSize: 20, showSizeChanger: true, showTotal: total => `共 ${total} 条` }}
              size="small"
              scroll={{ x: 700 }}
            />
          ) : (
            !loading && <Empty description="暂无违规作品" style={{ marginTop: 60 }} />
          )}
        </Spin>
      </div>
    </div>
  )
}
